import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import Logo from "../Images/logo 1.png";
import "../Styles/Navbar.css";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/contact", label: "Contact" },
    { path: "https://kaizennlg.simplicityniw.com/3f249eec-ddec-4dc0-9ee6-4f8d41425f71", label: "Kai-Zen Plan", external: true },
  ];

  return (
    <nav className={`navbar ${isScrolled ? "navbar-scrolled" : ""}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src={Logo} alt="Ebenezer Family Group" />
        </Link>

        <ul className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
          {navLinks.map((link) => (
            <li key={link.path}>
              {link.external ? (
                <a href={link.path} target="_blank" rel="noreferrer" onClick={closeMenu}>{link.label}</a>
              ) : (
                <Link to={link.path} className={location.pathname === link.path ? "active-link" : ""} onClick={closeMenu}>{link.label}</Link>
              )}
            </li>
          ))}
          <li className="navbar-cta-mobile">
            <Link to="/schedule-appointment" className="btn-primary" onClick={closeMenu}>Book Consultation</Link>
          </li>
        </ul>

        <Link to="/schedule-appointment" className="navbar-cta btn-primary">Book Consultation</Link>

        <button className="navbar-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <FontAwesomeIcon icon={isMenuOpen ? faXmark : faBars} />
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
